import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api";
import { hideLoader, showLoader } from "./loaderSlice";
import { showSnackBar } from "./snackSlice";

export const getAdminPayments = createAsyncThunk(
  "getAdminPayments",
  async (url = null, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `payments${url ? url : ""}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getClinicPayments = createAsyncThunk(
  "getClinicPayments",
  async (url = null, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `clinic/payments${url ? url : ""}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const deletePaymentById = createAsyncThunk(
  "deletePaymentById",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/delete/billing/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Payment removed successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getClinicBilling = createAsyncThunk(
  "getClinicBilling",
  async (url = null, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `pendingcalls/clinic/billing${url ? url : ""}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.appointmentList;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getInvoiceNumbersByCustomerId = createAsyncThunk(
  "getInvoiceNumbersByCustomerId",
  async (url = null, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/payments/invoice${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const cancelPaymentById = createAsyncThunk(
  "cancelPaymentById",
  async ({ id, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/payments/${id}/cancelled`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Payment cancelled successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createReturnOnBillingItems = createAsyncThunk(
  "createReturnOnBillingItems",
  async ({ id, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/return-payments/save-draft/${id}`,
        data,
      );

      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Returns applied successfully",
            type: "success",
          }),
        );
        return res?.data?.data ?? res?.data ?? true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateReturnOnBillingItems = createAsyncThunk(
  "updateReturnOnBillingItems",
  async ({ id, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/return-payments/${id}`,
        data,
      );

      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Returns applied successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateBillingItemsReturn = createAsyncThunk(
  "updateBillingItemsReturn",
  async ({ id, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/payments/${id}`,
        data,
      );

      if (res?.status === 200 || 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Returns applied successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createBillingReturn = createAsyncThunk(
  "createBillingReturn",
  async ({ id, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/add/credit/payments/${id}${url}`,
      );
      if (res?.status === 200 || 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Returns created successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updatePaymentModeByCollectionId = createAsyncThunk(
  "updatePaymentModeByCollectionId",
  async ({ collectionId, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/payment/collection/${collectionId}${url}`,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Payment mode updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Payment mode update failed!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Payment mode update failed!",
          type: "error",
        }),
      );
    }
  },
);

export const updateMultiCollectionStatusAndInvoiceNo = createAsyncThunk(
  "updateMultiCollectionStatusAndInvoiceNo",
  async (data, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/payment/collection/batch`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Collection changes updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Payment mode update failed!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Payment mode update failed!",
          type: "error",
        }),
      );
    }
  },
);

export const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    adminPayments: { totalRecords: 0, payments: [] },
    clinicPayments: { totalRecords: 0, payments: [] },
    billing: [],
    customerInvoices: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAdminPayments.fulfilled, (state, action) => {
      const payLoad = action.payload;
      state.adminPayments = {
        totalRecords: payLoad?.totalRecords,
        payments: payLoad?.data,
      };
    });
    builder.addCase(getClinicPayments.fulfilled, (state, action) => {
      const payLoad = action.payload;
      state.clinicPayments = {
        totalRecords: payLoad?.totalRecords,
        payments: payLoad?.data,
      };
    });
    builder.addCase(getClinicBilling.fulfilled, (state, action) => {
      state.billing = action.payload;
    });
    builder.addCase(
      getInvoiceNumbersByCustomerId.fulfilled,
      (state, action) => {
        state.customerInvoices = action.payload;
      },
    );
  },
});

export const {} = paymentSlice.actions;

export default paymentSlice.reducer;
